$(document).ready(function () {
    if ($(".cotizar-pegote").length) {
        $(".cotizar-pegote").fadeIn();
        $(".cerrar-cotizar").on("click", function () {
            $(".cotizar-pegote").fadeOut(function () {
                $(this).remove();
            });
        });
    }

    if ($("#cotizacion-modal").length) {
        $(".abre-cotizaciones-modal").on("click", function () {
            console.log("entro");
            $("#cotizacion-modal").modal("show");
            $("#cotizacion-modal")
                .find(".close")
                .on("click", function () {
                    $("#cotizacion-modal").modal("hide");
                });

            $("#cotizacion-modal")
                .on("shown.bs.modal", function (e) {
                    const $iframe = $(this).find("iframe");
                    $iframe.css("opacity", 1);
                })
                .on("hidden.bs.modal", function (e) {
                    const $iframe = $(this).find("iframe");
                    $iframe.attr("src", $iframe.attr("src")).css("opacity", 0);
                });
        });
    }
});
